import { render, staticRenderFns } from "./FrsLoadingIndicatorWrapper.vue?vue&type=template&id=33899439&scoped=true&"
import script from "./FrsLoadingIndicatorWrapper.vue?vue&type=script&lang=js&"
export * from "./FrsLoadingIndicatorWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33899439",
  null
  
)

export default component.exports